/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreFilter
 */

import React, { Component } from 'react';

export interface IStoreFilter {
  storeName?: string;
  storeFilter?: string;
  className?: string;
}

/**
 *
 * StoreFilter component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class StoreFilter extends Component {
  private readonly storeData: IStoreFilter[] = [
    { storeName: 'جميع المعارض', storeFilter: 'all', className: '' },
    { storeName: 'جدة', storeFilter: '1', className: '' },
    { storeName: 'الرياض', storeFilter: '2', className: '' },
    { storeName: 'المدينة المنورة', storeFilter: '5', className: '' },
    { storeName: 'الظهران', storeFilter: '7', className: '' },
    { storeName: 'الدمام', storeFilter: '8', className: '' },
   ];

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        {this.storeData.map((item) => (
          <li
            key={item.storeFilter}
            data-filter={item.storeFilter}
            className={item.className}
          >
            {item.storeName}
          </li>
        ))}
      </React.Fragment>
    );
  }
}

export default StoreFilter;
